<div class="general-container flex flex-col md:flex-row justify-center gap-32"
  [ngClass]="{'success': successOperation}">
  <div class="header flex flex-col divide-y divide-gray-10 gap-12 w-full md:w-1/3 p-20 rounded-xl bg-gray-10/[0.1]">
    <div class="titleContainer pb-16">
      <h2 class="font-sans text-eggplant-100 text-xl pb-16">{{ 'MOVEMENTS.MONEY-OUT.HOW-CHANGE' | translate }}</h2>
      <p class="font-sans text-eggplant-100 text-l">{{ 'MOVEMENTS.MONEY-OUT.HOW-CHANGE-INFO' | translate }}</p>
    </div>
  </div>

  <div class="content p-0 md:p-20">
    <div class="operation md:h-full" *ngIf="!successOperation">
      <form [formGroup]="bankForm" (submit)="save()">
        <div class="flex flex-col gap-20">

          <fun-input (keyup)="controlForm()"
            placeholder="{{ 'MOVEMENTS.MONEY-OUT.ACCOUNT-NAME-PLACEHOLDER' | translate }}" [parentForm]="bankForm"
            [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
            controlName="displayName" type="text" labelName="{{ 'MOVEMENTS.MONEY-OUT.ACCOUNT-NAME' | translate }}">
          </fun-input>

          <fun-input (selectChange)="controlForm()" placeholder="{{ 'MOVEMENTS.MONEY-OUT.SELECT-COUNTRY' | translate }}"
            [parentForm]="bankForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
            [isSubmit]="isSubmit" controlName="countryCode" type="select"
            labelName="{{ 'MOVEMENTS.MONEY-OUT.COUNTRY' | translate }}" [items]="countryList" [selectedItem]="'ES'">
          </fun-input>

          <fun-input (keyup)="controlForm()" placeholder="**** **** **** **** ****" [parentForm]="bankForm"
            [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="iban"
            type="text" labelName="{{ 'MOVEMENTS.MONEY-OUT.ACCOUNT_NUMBER' | translate }}" [isIban]="true">
          </fun-input>

          <ng-container *ngIf="isIndividual">
            <fun-input (keyup)="controlForm()"
              placeholder="{{ 'MOVEMENTS.MONEY-OUT.HOLDER-NAME-PLACEHOLDER' | translate }}" [parentForm]="bankForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="holderName" type="text" labelName="{{ 'MOVEMENTS.MONEY-OUT.HOLDER-NAME' | translate }}">
            </fun-input>
            <fun-input (keyup)="controlForm()"
              placeholder="{{ 'MOVEMENTS.MONEY-OUT.HOLDER-LASTNAME-PLACEHOLDER' | translate }}" [parentForm]="bankForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="holderLastName" type="text"
              labelName="{{ 'MOVEMENTS.MONEY-OUT.HOLDER-LASTNAME' | translate }}">
            </fun-input>
          </ng-container>

          <ng-container *ngIf="!isIndividual">
            <fun-input (keyup)="controlForm()"
              placeholder="{{ 'MOVEMENTS.MONEY-OUT.BUSINESS-NAME-PLACEHOLDER' | translate }}" [parentForm]="bankForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="businessName" type="text" labelName="{{ 'MOVEMENTS.MONEY-OUT.BUSINESS-NAME' | translate }}">
            </fun-input>
          </ng-container>

          <fun-input (keyup)="controlForm()" placeholder="{{ 'MOVEMENTS.MONEY-OUT.ADDRESS-PLACEHOLDER' | translate }}"
            [parentForm]="bankForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
            [isSubmit]="isSubmit" controlName="addressLine1" type="text"
            labelName="{{ 'MOVEMENTS.MONEY-OUT.ADDRESS' | translate }}">
          </fun-input>
          <p class="font-sans text-s text-alert -mt-12"
            *ngIf="bankForm.get('addressLine1').hasError('pattern') && (bankForm.get('addressLine1').dirty || isSubmit)">
            No se permiten caracteres especiales en la dirección
          </p>
          <fun-input (keyup)="controlForm()" placeholder="{{ 'MOVEMENTS.MONEY-OUT.CITY' | translate }}"
            [parentForm]="bankForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
            [isSubmit]="isSubmit" controlName="city" type="text"
            labelName="{{ 'MOVEMENTS.MONEY-OUT.CITY' | translate }}">
          </fun-input>
          <fun-input (keyup)="controlForm()" placeholder="{{ 'MOVEMENTS.MONEY-OUT.REGION' | translate }}"
            [parentForm]="bankForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
            [isSubmit]="isSubmit" controlName="region" type="text"
            labelName="{{ 'MOVEMENTS.MONEY-OUT.REGION' | translate }}">
          </fun-input>
          <fun-input (keyup)="controlForm()" placeholder="{{ 'MOVEMENTS.MONEY-OUT.POSTAL-CODE' | translate }}"
            [parentForm]="bankForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
            [isSubmit]="isSubmit" controlName="postalCode" type="text"
            labelName="{{ 'MOVEMENTS.MONEY-OUT.POSTAL-CODE' | translate }}">
          </fun-input>

          <div class="flex md:block items-center relative">
            <ion-skeleton-text *ngIf="isLoading" animated style="height: 48px; border-radius: 8px;"></ion-skeleton-text>
            <fun-new-button *ngIf="!isLoading" [buttonType]="sendXHR" [size]="'xl'" (eventClick)="save()"
              title="{{ 'MOVEMENTS.MONEY-OUT.CREATE-ACCOUNT' | translate }}" type="submit" class="w-full button">
            </fun-new-button>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="successOperation" class="sucess">
      <img src="../../assets/images/illustrations/plants.svg" alt="congratulations">
      <div class="w-full">
        <h2>{{ 'MOVEMENTS.MONEY-OUT.INCOMING-DATA' | translate }}</h2>
        <p>{{ 'MOVEMENTS.MONEY-OUT.CHECKING-INFO' | translate }}</p>
      </div>
      <div class="w-full">
        <fun-new-button [buttonType]="'primaryDark'" [size]="'xl'" title="{{ 'register.btn.accept' | translate }}"
          (eventClick)="reopenModal()" class="button" [classExtra]="' !w-full '">
        </fun-new-button>
      </div>
    </div>
  </div>
</div>